import React from 'react';
import { Loader2, X } from 'lucide-react';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  onSchedule,
  title,
  description,
  isLoading,
  confirmBtnText = 'Cancel',
  cancelBtnText = 'Delete',
  disableCancel = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-sm">
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="p-6">
          <button
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500 transition-colors"
            onClick={onClose}
            aria-label="Close modal"
          >
            <X className="h-5 w-5" />
          </button>
          
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
            <p className="text-sm text-gray-600 mb-6">{description}</p>
          </div>
          
          <div className="flex justify-center space-x-4">
            <button
              className={`flex-1 max-w-[160px] py-2.5 rounded-md border text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ${
                disableCancel
                  ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
              onClick={onSchedule || onClose}
              disabled={disableCancel}
            >
              {confirmBtnText}
            </button>
            
            <button
              className="flex-1 max-w-[160px] py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-70 disabled:cursor-not-allowed"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Processing...
                </div>
              ) : (
                cancelBtnText
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;